<template>
  <b-container class="d-flex align-items-center justify-content-center">
    <div id="login-main" class="spnod-admin__form--main d-flex align-items-center flex-column">
      <h3 class="h3 mb-4">Order Failure</h3>
      <p class="text-center mb-5">We are unable to process your payment at this time. Please contact your payment service provider for more information.</p>
      <b-button class="spnod-admin__form--button" type="submit" size="sm" @click="tryAgain()">Try Again</b-button>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'PaymentFailure',
  data () {
    return {
      title: 'Order Failure'
    }
  },
  methods: {
    tryAgain() {
      this.$router.go(-1)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/app/Pages/AdminAuth/PaymentFailure.vue?601c36f4